import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {

  @Input() title;
  @Input() message:string;
  @Input() richMessage:string;
  @Input() okButtonText:string = "Ok";
  @Input() cancelButtonText:string = "Cancel";
  @Input() okButtonColor = "danger";
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

}
